import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { formatPatientName } from '~/containers/patient-list/model';
import { PatientIdText } from '~/containers/patient-list/shared';
import type { ImportIdentity } from '../model';

/** A dropped patient's name, or the DICOM ID when the files carry none. Masked either way. */
export default function PatientLabel({
    identity,
}: {
    identity: ImportIdentity;
}) {
    const name = formatPatientName(identity.dicomPatientName);
    return name ? (
        <SensitiveInfoTypography>{name}</SensitiveInfoTypography>
    ) : (
        <PatientIdText id={identity.dicomPatientId} />
    );
}
